import { io } from "socket.io-client";

const socket = io(String(process.env.REACT_APP_SOCKETIO_URL));

export default socket
